import _ from 'lodash'
import {api} from "../api/apiCore";

export function getFleetIdlingDrivingSummary(company_id, start_ts, end_ts, device_ids) {
	let url = `/company/${company_id}/idling_driving_total?start_ts=${start_ts}&end_ts=${end_ts}`;
	if (device_ids) {
		url += `&device_ids=${device_ids}`;
	}

	return api.get(url);
}

export function getIdlingSummaryReport(company_id, start_date, end_date) {
    const url = `/reports/idling/summary?start_date=${start_date}&end_date=${end_date}&company_id=${company_id}`

	return api.get(url)
}

export function getIdlingBreakdownReport(company_id, start_date, end_date) {
    const url = `/reports/idling/breakdown?start_date=${start_date}&end_date=${end_date}&company_id=${company_id}`

	return api.get(url)
}

export function getSpeedingBreakdownReport(company_id, start_date, end_date) {
    const url = `/company/${company_id}/reports/speeding/breakdown?start_date=${start_date}&end_date=${end_date}`

	return api.get(url)
}

export function getSpeedingSummaryReport(company_id, start_date, end_date) {

    const url = `/company/${company_id}/reports/speeding/summary?start_date=${start_date}&end_date=${end_date}`

	return api.get(url)
}

export function getCustomReports(email) {

    const url = `/reports/custom/user/${email}`

	return api.get(url)
}

export function getCustomReportById(id, start_date, end_date, company_id) {

	const url = `/reports/custom/${id}/generate?start_date=${start_date}&end_date=${end_date}&company_id=${company_id}`;

	return api.get(url)
}

export function addCustomReport(data) {

    const url = `/reports/custom/add`;

	let form = new FormData();
	form.append('name', data.name);
    form.append('type', data.type);
    form.append('fields', data.fields);
    _.has(data, 'vehicles') ? form.append('device_ids', data.vehicles) : false
    _.has(data, 'users') ? form.append('users', data.users) : false

	return api.putForm(url, form);
}

export function updateReport(id, data) {

	let url = `/reports/custom/${id}`;

	let form = new FormData()

    _.has(data, 'name') ? form.append('name', data.name) : false
    _.has(data, 'fields') ? form.append('fields', data.fields) : false
    _.has(data, 'users') ? form.append('users', data.users) : false
    _.has(data, 'vehicles') ? form.append('vehicles', data.vehicles) : false

	return api.postForm(url, form);
}

export function deleteCustomReport(id){
	let url = `/reports/custom/${id}`;

	return api.delete(url);
}

export function getReportSubscriptions(email, fields = null) {

	let url = `/reports/subscriptions/${email}`;

	if (fields) {
		url += ('?' + fields)
	}

	return api.get(url)
}

export function addReportSubscription(data) {

    const url = `/reports/subscriptions`;

	let form = new FormData();
	form.append('report_id', data.report_id);
	form.append('report_type', data.report_type);
    form.append('subscribers', data.subscribers);
    form.append('frequency', data.frequency);
    if (_.has(data, 'additional')) form.append('additional', data.additional)
    if (_.has(data, 'day_run')) form.append('day_run', data.day_run)
    form.append('company_id', data.company_id);

	return api.putForm(url, form);
}

export function updateReportSubscription(data) {
	let url = `/reports/subscriptions/${data.id}`;

	let form = new FormData()

	if (_.has(data, 'frequency')) form.append('frequency', data.frequency)
    if (_.has(data, 'day_run')) form.append('day_run', data.day_run)
    if (_.has(data, 'subscribers')) form.append('subscribers', data.subscribers)
    if (_.has(data, 'additional')) form.append('additional', data.additional)

	return api.postForm(url, form);
}

export function deleteReportSubscription(id){
	let url = `/reports/subscriptions/${id}`;

	return api.delete(url);
}

export function setReportAddressList(data) {
	const url = `/address/list`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form);
}

export function getRecordingLogGaps(data) {
	let params = '';
	for (const key in data) {
		params += `${(!params ? '?' : '&')}${key}=${data[key]}`
	}
	const url = `/reports/recording_log/gaps${params}`;

	return api.get(url);
}

export function getEventBreakdownReport(data) {
	const { company_id, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/companies/${company_id}/reports/event_type${params}`;

	return api.get(url);
}

export function getEventTypeCounts(data) {
	let params = '';
	for (const key in data) {
		if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
			params += `${(!params ? '?' : '&')}${key}=${data[key]}`
		}
	}

	const url = `/reports/event_type${params}`;

	return api.get(url);
}

export function getDriverEventBreakdownReport(data) {
	const { company_id, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/companies/${company_id}/reports/driver/event_breakdown${params}`;

	return api.get(url);
}

export function getDriverEventPerformanceReport(data) {
	const { company_id, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/companies/${company_id}/reports/driver/event_performance${params}`;

	return api.get(url);
}

export function getDataTrackingCompanies(data) {
	let params = '';
	for (const key in data) {
		params += `${(!params ? '?' : '&')}${key}=${data[key]}`
	}

	const url = `/reports/data_tracking/companies${params}`;

	return api.get(url);
}

export function getExitEntryReport(data) {
	const { company_id, id, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/companies/${company_id}/zones/${id}/exit-entry${params}`;

	return api.get(url);
}

export function getMovementsReport(data) {
	const { company_id, zoneId, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}

	const url = `/companies/${company_id}/zones/${zoneId}/movements${params}`;

	return api.get(url);
}

export function getStopReport(data) {
	let params = '';
	for (const key in data) {
		params += `${(!params ? '?' : '&')}${key}=${data[key]}`
	}

	const url = `/devices/stops${params}`;

	return api.get(url);
}

export function getPairedGeotabDevices(data) {
	const { company_id } = data;

	const url = `/reports/paired_geotab_devices/${company_id}`;

	return api.get(url);
}

export function getDataTrackingDevices(data) {
	let params = '';
	for (const key in data) {
		params += `${(!params ? '?' : '&')}${key}=${data[key]}`
	}

	const url = `/reports/data_tracking/devices${params}`;

	return api.get(url);
}

export function getIFTAReportsList(data) {
	let params = '';
	for (const key in data) {
		if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
			params += `${(!params ? '?' : '&')}${key}=${encodeURIComponent(data[key])}`
		}
	}

	const url = `/reports/list${params}`;

	return api.get(url);
}

export function generateHistoryReport(data) {
	const url = `/reports/route_history`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form);
}

export function exportHistoryReport(data) {
	const url = `/reports/route_history/export`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form, { responseType: 'blob' });
}
